import { noddiAsync, URLKeys } from 'noddi-async';
import { splitNoticesByPlacement } from 'noddi-web';
import { useLocation } from 'react-router-dom';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { noticeMatchesTimePicker, resolveCustomerTimePickerSurface } from './customerTimePickerSurface';
import { useTimePickerNoticeSurfaceStore } from './timePickerNoticeSurfaceStore';

/** Mobile pickers resolve the department like delivery windows: address + sales items. */
type PickerContext = { serviceDepartmentId?: number; addressId?: number; selectedSalesItemIds?: number[] };

/** Time pickers use department context; page banners use the brand. */
export const useCustomerNotices = (context?: PickerContext) => {
  const { pathname } = useLocation();
  const published = useTimePickerNoticeSurfaceStore((state) => state.surface);
  const surface = resolveCustomerTimePickerSurface(pathname, published);
  const { currentBrand } = useCurrentBrand();
  const { data: brand, isPending: isBrandPending } = noddiAsync.useGet({
    type: URLKeys.getByDomainBrand,
    input: { brandDomain: currentBrand }
  });
  const noticesQuery = noddiAsync.useGet({
    type: URLKeys.getPublicNotices,
    input: { brandId: brand?.id, ...context, brandDomain: context?.addressId ? currentBrand : undefined },
    queryConfig: {
      enabled: !isBrandPending,
      staleTime: 60_000,
      refetchInterval: 5 * 60_000
    }
  });

  const notices = noticesQuery.data ?? [];
  const headerNotices = notices.filter(
    (notice) => notice.showInCustomerApp && !(surface && noticeMatchesTimePicker(notice, surface))
  );
  const pickerNotices = surface ? notices.filter((notice) => noticeMatchesTimePicker(notice, surface)) : [];
  const picker = splitNoticesByPlacement(pickerNotices);

  return {
    isBrandPending,
    error: noticesQuery.error,
    ...splitNoticesByPlacement(headerNotices),
    pickerContent: picker.content,
    pickerTop: picker.top
  };
};
